import React, { useEffect } from 'react';
import { Switch, useHistory } from 'react-router-dom';
import RouteComp, { routes } from './RouteComp';
import { usePageTracking } from '../core/hooks';
import { useProfileContext } from '../core/profile/ProfileProvider';

function Routes() {
  // BrowserRouter needed to be moved out of this component to let usePageTracking work.
  usePageTracking();
  const history = useHistory();
  const { useCurrentStep } = useProfileContext();
  const { currentStep } = useCurrentStep();

  // useEffect(() => {
  //   if (currentStep !== 'home') {
  //     history.push(`/${currentStep}`);
  //   }
  // }, []);

  return (
    <Switch>
      {routes.map(route => {
        return <RouteComp key={route.path} {...route} />;
      })}
    </Switch>
  );
}

export default Routes;
